/**
 * Force Hamburger Menu on Desktop
 * Yeh code desktop par bhi hamburger menu show karega
 */

// DOM ready hone ka wait karo
document.addEventListener('DOMContentLoaded', function() {
  
  // Header menu ko hide karo (jo desktop par normal menu hai)
  const headerMenu = document.querySelector('header-menu.header-menu');
  if (headerMenu) {
    headerMenu.style.display = 'none';
  }
  
  // Hamburger drawer ko force show karo desktop par bhi
  const headerDrawer = document.querySelector('.header__drawer');
  if (headerDrawer) {
    // Mobile:hidden class remove karo agar hai
    headerDrawer.classList.remove('mobile:hidden');
    headerDrawer.classList.remove('desktop:hidden');
    
    // Display force karo
    headerDrawer.style.display = 'block';
  }
  
  // Drawer container ko bhi visible karo
  const drawerContainer = document.querySelector('.header__drawer--mobile');
  if (drawerContainer) {
    drawerContainer.style.display = 'block';
  }

  // Header drawer element ko bhi check karo
  const headerDrawerElement = document.querySelector('header-drawer');
  if (headerDrawerElement) {
    headerDrawerElement.style.display = 'block';
  }

  console.log('✅ Hamburger menu forced on desktop!');
});

window.addEventListener('resize', function() {
  const headerMenu = document.querySelector('header-menu.header-menu');
  const headerDrawer = document.querySelector('.header__drawer');
  
  if (headerMenu) {
    headerMenu.style.display = 'none';
  }
  
  if (headerDrawer) {
    headerDrawer.style.display = 'block';
  }
});

// CSS override via JavaScript (alternative method)
function forceHamburgerStyles() {
  const style = document.createElement('style');
  style.textContent = `
    /* Force hamburger menu on desktop */
    header-menu.header-menu,
    .header-menu {
      display: none !important;
    }
    
    .header__drawer,
    header-drawer {
      display: block !important;
    }
    
    .header__drawer.desktop\\:hidden,
    .header__drawer.mobile\\:hidden {
      display: block !important;
    }
    
    /* Hamburger icon ko desktop par bhi show karo */
    .header__icon--menu {
      display: flex !important;
    }
    
    /* Menu drawer ko properly style karo desktop ke liye */
    @media screen and (min-width: 990px) {
      .header__drawer {
        display: block !important;
      }
      
      .menu-drawer {
        width: 400px;
      }
    }
  `;
  document.head.appendChild(style);
  console.log('✅ CSS styles injected for hamburger menu!');
}

// Styles inject karo
forceHamburgerStyles();




document.addEventListener("DOMContentLoaded", function () {
  const logoURL = "https://cdn.shopify.com/s/files/1/0670/5761/4950/files/Bougie-Bird-Dog-Woodworking-LLC-01-2048x633.webp?v=1764193613";

  function insertLogo() {
    const drawer = document.querySelector(".menu-drawer__navigation");

    // Drawer not found yet → retry
    if (!drawer) {
      setTimeout(insertLogo, 300);
      return;
    }

    // Prevent duplicate logo insertion
    if (document.querySelector(".drawer-logo-wrapper")) return;

    // Create Logo Element
    const logoDiv = document.createElement("div");
    logoDiv.className = "drawer-logo-wrapper";
    logoDiv.innerHTML = `
      <a href="/" class="drawer-logo-link">
        <img src="${logoURL}" alt="Logo" class="drawer-logo-img">
      </a>
    `;

    // Insert logo above drawer
    drawer.insertAdjacentElement("beforebegin", logoDiv);
  }

  insertLogo(); // Run on load

  // Run again when drawer is opened (Shopify AJAX loading fix)
  document.body.addEventListener("click", function () {
    setTimeout(insertLogo, 200);
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--ANHdSYThmUk9CeTNCZ__button_H9gpTf");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="e-font-icon-svg e-fas-cart-arrow-down" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"></path>
      </svg>
    `;

    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--AYWRzTWpycUlMbVc4R__button_MzMFex");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="button-arrow-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
      </svg>
    `;

    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--AQ2VtS2RXM3BhSVFNb__button_zxPVyW");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="button-arrow-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
      </svg>
    `;

    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--AS0hMYVV0bDFiSnUvS__button_QRbbMD");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="button-arrow-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
      </svg>
    `;

    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--AVG5lQTRwSEZ0SlVEN__button_ebL6hK");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="button-arrow-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
      </svg>
    `;

    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--AcFJQM29BcmVFczdwO__button_bagTmB");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="button-arrow-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
      </svg>
    `;

    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--AQXRXNFlycTVtQmhxU__button_74P6i3");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="button-arrow-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
      </svg>
    `;

    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--AV2QxYW4vSkV0cWlxd__button_bagTmB");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="button-arrow-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
      </svg>
    `;

    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--AYnlkNWtnbG4xSlM0e__button_9hLn6P");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="button-arrow-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
      </svg>
    `;
    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--AazFibXlaQ2loKzhpa__button_LEh7fV");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="button-arrow-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
      </svg>
    `;
    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector("a.size-style.button.button--AdTE3Tk1yajZzWVU3S__button_9A3i8N");

  if (btn) {
    const svgIcon = `
      <svg aria-hidden="true" class="button-arrow-icon" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
      </svg>
    `;
    btn.insertAdjacentHTML("beforeend", svgIcon);
  }
});












document.addEventListener('DOMContentLoaded', () => {
  // Inline SVGs
  const svgs = {
    pin: `<svg aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/></svg>`,
    phone: `<svg aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1v3.5a1 1 0 01-1 1C10.07 22 2 13.93 2 3.5A1 1 0 013 2.5H6.5a1 1 0 011 1c0 1.24.2 2.45.57 3.57.13.33.03.7-.24 1.01l-2.21 2.21z"/></svg>`,
    mail: `<svg aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>`
  };

  // Find candidate lists (rte-formatter or text-block) that look like contact lists
  const lists = Array.from(document.querySelectorAll('rte-formatter ul, .text-block ul, .contact-list, .footer-utilities__list, .menu-contact ul'));

  lists.forEach((ul) => {
    // Skip if we've already processed this list
    if (ul.classList.contains('rte-contact-processed')) return;

    const lis = ul.querySelectorAll('li');
    if (lis.length === 0) return;

    // Mark processed
    ul.classList.add('rte-contact', 'rte-contact-processed');

    // Add icons to first three list items if present
    const targets = [svgs.pin, svgs.phone, svgs.mail];
    for (let i = 0; i < 3; i++) {
      const li = lis[i];
      if (!li) break;
      // Avoid duplicating
      if (li.querySelector('.contact-icon')) continue;

      const span = document.createElement('span');
      span.className = 'contact-icon';
      span.setAttribute('aria-hidden', 'true');
      span.innerHTML = targets[i];
      // Insert icon at start
      li.insertBefore(span, li.firstChild);
    }

    // ensure links inside the list inherit color (in case li contains <a>)
    ul.querySelectorAll('a').forEach(a => {
      a.style.color = 'inherit';
    });
  });
});





(function () {
  const SELECTOR_EXACT = 'rte-formatter.text-block--AUnQ3d2FZWWo0TUtrN__text_tkjbbh p';

  // create SVG node (arrow) using createElementNS for reliability
  function createArrowSvg() {
    const svgns = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgns, "svg");
    svg.setAttribute("viewBox", "0 0 448 512");
    svg.setAttribute("aria-hidden", "true");
    svg.classList.add("shop-icon-svg");

    const path = document.createElementNS(svgns, "path");
    path.setAttribute("d", "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z");
    svg.appendChild(path);
    return svg;
  }

  function addIconToParagraph(p) {
    if (!p || p.dataset.shopIconProcessed === "1") return;

    // append the SVG after existing text content
    p.classList.add("shop-icon-text");
    const svg = createArrowSvg();
    // append only if there's no existing svg.shop-icon-svg
    if (!p.querySelector("svg.shop-icon-svg")) {
      p.appendChild(svg);
    }

    p.dataset.shopIconProcessed = "1";
  }

  // scan and add icons to matching paragraphs
  function scanAndApply() {
    // 1) exact selector for the block you showed
    const exactEls = Array.from(document.querySelectorAll(SELECTOR_EXACT));
    exactEls.forEach(addIconToParagraph);

    // 2) fallback: any rte-formatter p with text "SHOP NOW" (case-insensitive)
    const fallback = Array.from(document.querySelectorAll("rte-formatter p, .text-block p, p"));
    fallback.forEach(p => {
      if (p && !p.dataset.shopIconProcessed) {
        if (p.textContent && p.textContent.trim().toUpperCase() === "SHOP NOW") {
          addIconToParagraph(p);
        }
      }
    });
  }

  // initial attempt
  document.addEventListener("DOMContentLoaded", () => {
    scanAndApply();
  });

  // MutationObserver to catch dynamically injected content
  const observer = new MutationObserver((mutations) => {
    // small debounce: call scan once per batch
    let needs = false;
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) { needs = true; break; }
    }
    if (needs) scanAndApply();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Safety: run once more after 2s in case of slow scripts
  setTimeout(scanAndApply, 2000);
})();










(function () {
  if (!window.location.pathname.includes('/collections/all')) return;

  const HIDDEN_TAG = 'hidden products';

  async function checkAndHideProduct(card) {
    const link = card.querySelector('a[href^="/products/"]');
    if (!link) return;

    const handle = link.href
      .split('/products/')[1]
      .split('?')[0];

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return;

      const product = await res.json();

      if (
        product.tags &&
        product.tags.map(t => t.toLowerCase()).includes(HIDDEN_TAG)
      ) {
        card.style.display = 'none';
      }
    } catch (e) {
      console.warn('Product check failed:', handle);
    }
  }

  function init() {
    document
      .querySelectorAll('li[data-product-id]')
      .forEach(checkAndHideProduct);
  }

  // Initial load (Shopify loads products async)
  setTimeout(init, 600);

  // Observe future product loads (pagination / infinite scroll)
  const observer = new MutationObserver(init);
  observer.observe(document.body, { childList: true, subtree: true });
})();
